const REPORT_TYPES = {
  COMPLETE: 'reportComplete',
  BY_BANNER: 'reportByBanner',
}

const CONSENT_TYPE_OPTIONS = [
  { id: 'full', name: 'Aceito' },
  { id: 'denied', name: 'Rejeitado' },
  { id: 'partial', name: 'Parcial' },
]

const reports = {
  REPORT_TYPES,
  CONSENT_TYPE_OPTIONS,
}

export default reports
